module.exports = __webpack_public_path__ + "static/media/solar-step-6.17ea1b5a.png";